import React from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';

const Footer: React.FC = () => {
  const location = useLocation();

  // Only show footer on homepage
  if (location.pathname !== '/') {
    return null;
  }

  return (
    <footer className="app-footer">
      &copy; {new Date().getFullYear()} 10D Club LLC. All rights reserved. |
      <a href="/legal/terms/latest" className="footer-link" target="_blank" rel="noopener noreferrer"> Terms & Policies</a> |
      <a href={`${API_BASE_URL}/docs`} className="footer-link" target="_blank" rel="noopener noreferrer"> API Docs</a> |
      Contact us at <a href="mailto:info@gpcommit.com" className="footer-link">info@gpcommit.com</a>
    </footer>
  );
};

export default Footer;
